import { isPlainObject } from 'lodash';
import { DEFAULT_ERROR_MESSAGE } from '@constants';
import { camelCaseProps } from '@helpers';

export default class CalculatorError extends Error {
  constructor(data) {
    let message = null;
    let errorData = {};
    let hasGeneralError = false;
    let hasValidationError = false;

    if (isPlainObject(data)) {
      if (
        isPlainObject(data.validation) &&
        Object.keys(data.validation).length
      ) {
        hasValidationError = true;
        errorData.validation = camelCaseProps(data.validation);
        message = 'Invalid user inputs';
        delete data.validation;
      } else {
        hasGeneralError = true;
      }

      const keys = Object.keys(data);

      if (keys.length) {
        errorData = data;
        message = data.general ?? data[Object.keys(data)[0]] ?? message;
        hasGeneralError = true;
      }
    } else {
      errorData.general = DEFAULT_ERROR_MESSAGE;
      hasGeneralError = true;
    }

    super(message ?? DEFAULT_ERROR_MESSAGE);

    this.name = 'CalculatorError';
    this.data = errorData;
    this.isValidation = hasValidationError;
    this.isGeneral = hasGeneralError;
  }
}
